import { useEffect } from "react"
import { Input } from "@stardust-ds/react"
import intl from "react-intl-universal"

import SearchIcon from "../../../assets/icons/SearchIcon"
import CloseIcon from "../../../assets/icons/CloseIcon"
import styles from "./index.module.scss"
import { debounce } from "../../../utils/debounce"
import useFocus from "../../../hooks/useFocus"

export default function SearchBar(props) {
  const { setSearchActive, setSearchTerm, fnSetBVisibleCtext } = props

  const [inputRef, setFocus] = useFocus()

  useEffect(() => {
    setFocus()
  }, [])

  const handleSearchTerm = (e) => {
    e.preventDefault()
    setSearchTerm(e.target.value)
  }

  return (
    <div className={styles.searchContainer}>
      <Input
        autoComplete="off"
        ref={inputRef}
        isFullWidth
        height={64}
        bColor={"transparen"}
        className={styles.inputSearch}
        placeholder={intl.get("type")}
        iconLeft={<SearchIcon className={styles.searchIconInput} />}
        onChange={debounce((e) => handleSearchTerm(e), 1000)}
      />
      <CloseIcon
        className={styles.closeButton}
        fill={"#6CB6E3"}
        onClick={() => {
          setSearchActive((e) => !e)
          fnSetBVisibleCtext(true)
        }}
      />
    </div>
  )
}
